import { ANALYTICS_EVENTS } from "./constants";
import type { AnalyticsStaticData, PageViewEvent } from "./types";

interface PageViewEventFromAnalyticsStaticDataInput {
  analyticsStaticData: AnalyticsStaticData;
  contentGroup: string;
  pathname: string;
}

/**
 * 既存 `page_view` と同じ payload を作ります。
 *
 * この payload はコンサルタントが参照している既存 GA4 レポートとの互換性を保つため、
 * `userid` / `orgid` / `orgname` / `company_name` / project-view-job names を残しています。
 * 新規 custom event ではこの形を再利用せず、`custom-events.ts` の typed catalog に定義した
 * 低カーディナリティ parameter を使います。削除・縮小は関係者合意後に別 ADR で判断します。
 */
export function pageViewEventFromAnalyticsStaticData({
  analyticsStaticData,
  contentGroup,
  pathname,
}: PageViewEventFromAnalyticsStaticDataInput): PageViewEvent {
  const { userData, orgData, employeeStatus, workspaceId, nodeNames } =
    analyticsStaticData;

  let iwjobname: string | undefined;
  let projname: string | undefined;
  let saviewname: string | undefined;
  let uaviewname: string | undefined;

  if (pathname.includes("/iw/")) {
    iwjobname = nodeNames.workerName;
    projname = nodeNames.projectName;
  } else if (pathname.includes("/sa/")) {
    saviewname = nodeNames.viewName;
    projname = nodeNames.projectName;
  } else if (pathname.includes("/ua/")) {
    uaviewname = nodeNames.viewName;
    projname = nodeNames.projectName;
  } else if (pathname.includes("/dashboards/")) {
    projname = nodeNames.dashboardName;
  } else {
    projname = nodeNames.projectName;
  }

  return {
    event: ANALYTICS_EVENTS.PAGE_VIEW,
    userid: userData?.id || "unknown",
    orgid: orgData?.id || workspaceId || "unknown",
    orgname: orgData?.name || "unknown",
    content_group: contentGroup,
    plan: orgData?.planName || "unknown",
    employees: employeeStatus,
    company_name: orgData?.name || "unknown",
    ...(iwjobname && { iwjobname }),
    ...(projname && { projname }),
    ...(saviewname && { saviewname }),
    ...(uaviewname && { uaviewname }),
  };
}
